import React, { useContext } from "react";
import { ModuleUsageTable, StatisticsContainer } from "modules/common";
import { AccessibilityContext } from "views/AccessibilityContext";

interface Props {
    columns: any;
    data: {
        label: string;
        web: number;
        mobile: number;
    }[];
}
export const ModuleUsageStats: React.FC<Props> = ({ columns, data }) => {
    const { lowVision } = useContext(AccessibilityContext);
    return (
        <StatisticsContainer title="Moduli po korištenju" className={lowVision ? "low-vision-darkgray" : ""}>
            <div className="module-table-container">
                <ModuleUsageTable columns={columns} data={data} />
            </div>
        </StatisticsContainer>
    );
};
